import { render, staticRenderFns } from "./CartOrderTable.vue?vue&type=template&id=07a8ff46&"
import script from "./CartOrderTable.vue?vue&type=script&lang=js&"
export * from "./CartOrderTable.vue?vue&type=script&lang=js&"
import style0 from "./CartOrderTable.vue?vue&type=style&index=0&id=07a8ff46&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports